import React from 'react';
import type TravelerInformation from '@this/src/domain/traveler_information';
import type NonOrderItem from '@this/src/domain/non_order_item2';
import ContentInfo from './content_info';

interface Props {
  item: NonOrderItem;
  traveler: TravelerInformation;
  total: number;
  type: string;
}

const ContentForNonOrderItem: React.FC<Props> = ({ item, traveler, total, type }) => {
  // TODO: findでいいの？全件回す必要ありそう？
  const nonOrderItemMapping = item.nonOrderItemMappings.find(m => m.travelerInformationId === traveler.id);
  if (!nonOrderItemMapping) {
    return null;
  }

  if (type === 'department' && nonOrderItemMapping.chargingDepartmentShareId) {
    return null;
  }
  if (type === 'project' && nonOrderItemMapping.projectShareId) {
    return null;
  }
  const price = item.price.price || 0;
  const amount = price / (total || 1);

  let itemName = '';
  if (type === 'department') {
    itemName = nonOrderItemMapping.chargingDepartment?.descriptionWithCode() || '';
  } else if (type === 'project') {
    itemName = nonOrderItemMapping.project?.codeAndName() || '';
  } else if (type === 'account') {
    itemName = `${nonOrderItemMapping.expensesAccountType?.code}:${nonOrderItemMapping.expensesAccountType?.name}`;
  }

  return <ContentInfo item={item} traveler={traveler} price={amount} itemName={itemName} index={traveler.id} />;
};

export default ContentForNonOrderItem;
